/**
 * Shared form styles for MuseIQ Lit components.
 * Provides .form-group, .error-message, .form-actions, .form-hint styles.
 */
import { css } from 'lit';

export const formStyles = css`
    .form-group {
        margin-bottom: 1.25rem;
        width: 100%;
    }

    .form-group label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: var(--text-primary, #f1f5f9);
    }

    .form-group input[type="text"],
    .form-group input[type="password"],
    .form-group input[type="file"],
    .form-group select {
        width: 100%;
        padding: 0.75rem;
        background: var(--background, #0f172a);
        border: 1px solid var(--border, #475569);
        border-radius: 6px;
        color: var(--text-primary, #f1f5f9);
        font-size: 1rem;
        font-family: inherit;
    }

    .form-group input[type="text"]:focus,
    .form-group input[type="password"]:focus,
    .form-group select:focus {
        outline: none;
        border-color: var(--primary-color, #2563eb);
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
    }

    .form-group input[type="file"] {
        padding: 0.5rem;
    }

    .form-group select {
        appearance: none;
        cursor: pointer;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23cbd5e1' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 1rem center;
        padding-right: 2.5rem;
    }

    .form-hint {
        font-size: 0.85rem;
        color: var(--text-secondary, #cbd5e1);
        margin-top: 0.25rem;
    }

    .form-actions {
        display: flex;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .form-actions .btn {
        flex: 1;
    }

    .error-message {
        color: var(--error-color, #ef4444);
        font-size: 0.875rem;
        text-align: center;
        margin: 1rem 0;
        padding: 0.75rem;
        background-color: rgba(239, 68, 68, 0.1);
        border: 1px solid var(--error-color, #ef4444);
        border-radius: 0.375rem;
    }
`;
